var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0H.5A.5.5,0,0,0,0,.5v10a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,.5-.5V.5A.5.5,0,0,0,10.5,0ZM10,10H1V1h9ZM23.5,0h-10a.5.5,0,0,0-.5.5v10a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,.5-.5V.5A.5.5,0,0,0,23.5,0ZM23,10H14V1h9ZM10.5,13H.5a.5.5,0,0,0-.5.5v10a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,.5-.5v-10A.5.5,0,0,0,10.5,13ZM10,23H1V14h9ZM23.5,13h-10a.5.5,0,0,0-.5.5v10a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,.5-.5v-10A.5.5,0,0,0,23.5,13ZM23,23H14V14h9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareView);
export default __webpack_public_path__ + "static/media/square-view.2aea170ad74a70a814eddc544fc4aefb.svg";
export { ForwardRef as ReactComponent };